import * as Dialog from "@radix-ui/react-dialog";
import * as Dropdown from "@radix-ui/react-dropdown-menu";
import { X, MoreHorizontal, Check, ArrowUpRight } from "lucide-react";
import type { ReactNode } from "react";
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand">
      <img src="/logo.svg" alt="" />
      {!compact && (
        <span>
          ply<span className="brand-dot">.</span>
        </span>
      )}
    </span>
  );
}
export function Modal({
  title,
  description,
  children,
  onClose,
  wide = false,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
}) {
  return (
    <Dialog.Root open onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className={`dialog ${wide ? "dialog-wide" : ""}`}>
          <div className="dialog-header">
            <div>
              <Dialog.Title>{title}</Dialog.Title>
              <Dialog.Description>
                {description || "Manage your Ply workspace."}
              </Dialog.Description>
            </div>
            <Dialog.Close className="icon-button" aria-label="Close dialog">
              <X size={19} />
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
export function Menu({
  children,
  label = "More options",
  trigger,
}: {
  children: ReactNode;
  label?: string;
  trigger?: ReactNode;
}) {
  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <button className="icon-button" aria-label={label}>
          {trigger || <MoreHorizontal size={19} />}
        </button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content className="dropdown" align="end" sideOffset={8}>
          {children}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
}
export function MenuItem({
  children,
  onClick,
  danger = false,
  disabled = false,
}: {
  children: ReactNode;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
}) {
  return (
    <Dropdown.Item
      disabled={disabled}
      className={`menu-item ${danger ? "danger" : ""}`}
      onSelect={onClick}
    >
      {children}
    </Dropdown.Item>
  );
}
export function Empty({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="empty-illustration">
        <div className="mini-note" />
        <div className="mini-note blue" />
        <ArrowUpRight size={38} />
      </div>
      <h2>{title}</h2>
      <p>{description}</p>
      {children}
    </div>
  );
}
export function Avatar({
  name,
  color,
  size = 30,
}: {
  name: string;
  color?: string;
  size?: number;
}) {
  return (
    <span
      className="avatar"
      style={{
        background: color || "#eceeff",
        color: color ? "white" : "#3559c8",
        width: size,
        height: size,
      }}
      title={name}
    >
      {name
        .split(" ")
        .map((w) => w[0])
        .slice(0, 2)
        .join("")
        .toUpperCase()}
    </span>
  );
}
export function Notice({
  children,
  error = false,
}: {
  children: ReactNode;
  error?: boolean;
}) {
  return (
    <div
      role={error ? "alert" : "status"}
      className={`notice ${error ? "error" : ""}`}
    >
      <Check size={16} />
      {children}
    </div>
  );
}
export const SYMBOLS = [
  "💡",
  "🎬",
  "🧠",
  "🚀",
  "🔎",
  "✨",
  "📌",
  "🎨",
  "🌊",
  "📚",
  "🧩",
  "🎮",
  "🪐",
  "⚡",
  "🌿",
  "🍊",
  "🎯",
  "📝",
  "🛸",
  "📺",
];
